<lib-cover
  [delayedCalc]="true"
  [imageSize]="$safeNavigationMigration((coverDetails$ | async)?.size)"
  [point]="$safeNavigationMigration((coverDetails$ | async)?.point)"
  [url]="$safeNavigationMigration((coverDetails$ | async)?.url)"
  [isBooking]="isBooking"
></lib-cover>
